export function isPublicPortal(): boolean {
  const publicHostNames = ['localhost:3003', 'public.ftrdev.com', 'public.fortherecord.com']
  const hostName = window.location.host
  return publicHostNames.includes(hostName)
}
